import verifyLabel from '../../../../methods/verifyLabel'

export default {
    name: 'SortDropdown',
    data(){
        return {
            selectedSorting: 0 ,
            options: [
                {
                    sortBy: 'title',
                    sortOrder: 'asc',
                    label: 'sort-title-asc-label',
                    selected: true
                },
                {
                    sortBy: 'title',
                    sortOrder: 'desc',
                    label: 'sort-title-desc-label',
                    selected: false
                },
                {
                    sortBy: 'price',
                    sortOrder: 'asc',
                    label: 'sort-price-asc-label',
                    selected: false
                } ,
                {
                    sortBy: 'price',
                    sortOrder: 'desc',
                    label: 'sort-price-desc-label',
                    selected: false
                }
            ]
        }
    },
    computed:{
        sortOptionsFromSearchConfig(){
            const searchConfig = this.$store.state.search.searchConfig
            return {
                sortOrder: searchConfig.sortOrder,
                sortBy: searchConfig.sortBy
            }
        }
    },
    methods: {
        performSearchWithSort(){
            const newSort = this.options[this.selectedSorting]

            const sortConfig = {
                sortOrder: newSort.sortOrder,
                sortBy: newSort.sortBy
            }

            if(newSort.default === true){
                delete sortConfig.sort
                delete sortConfig.sortBy
            }

            const newSearchConfig = Object.assign({},this.$store.state.search.searchConfig,sortConfig)
            this.$store.commit('search/setSearchConfig',newSearchConfig)
            this.$store.dispatch('search/performSearch')
        },
        verifyLabel(displayName){
            return verifyLabel(displayName, this.$store.state.main.labels)
        }
    },
    watch:{
        sortOptionsFromSearchConfig(newOptions){
            let selectedSorting = 0
            this.options.forEach((option,index)=>{
                const sameSortBy = (newOptions.sortBy === option.sortBy)
                const sameSortOrder = (newOptions.sortOrder === option.sortOrder)
                if(sameSortBy && sameSortOrder){
                    selectedSorting = index
                }
            })
            this.selectedSorting = selectedSorting
        }
    }
}